"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const unwrap_1 = __importDefault(require("../../util/unwrap"));
const GoogleMapsController_1 = __importDefault(require("./GoogleMapsController"));
class PlaceController {
    static async details(placeId, fields, options) {
        return GoogleMapsController_1.default.request('place/details', [['place_id', placeId], (0, unwrap_1.default)(fields, it => ['fields', it.join(',')])].filter(Boolean), options);
    }
    static async autocomplete(input, location, options) {
        return GoogleMapsController_1.default.request('place/autocomplete', [['input', input], location ? ['location', `${location[0]}%2C${location[1]}`] : undefined].filter(Boolean), options);
    }
}
exports.default = PlaceController;
